import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const RowanTheme = createTheme({
  palette: {
    mode: "dark",
  },
});
